/**
 * Copyright (C) 2025 GIP-RECIA, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import type { GroupsApiResponse, Soffit } from '../types/index.ts'

export default class GroupsService {
  static async get(
    soffit: Soffit,
    groupsApiUrl: string,
  ): Promise<GroupsApiResponse | undefined> {
    try {
      const { token } = soffit

      const response = await fetch(groupsApiUrl, {
        method: 'GET',
        headers: {
          Authorization: token,
        },
        signal: AbortSignal.timeout(10_000),
      })

      if (!response.ok)
        throw new Error(response.statusText)

      return await response.json()
    }
    catch (error) {
      console.error(error, groupsApiUrl)
      return undefined
    }
  }
}
